












import {Component, Emit, Vue} from "vue-property-decorator";

@Component({})
export default class ConfigButton extends Vue {
  @Emit()
  protected click() {
    //
  }
}
